import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import {
  HIGHLIGHTS_SET_FILTER,
  HighlightsAction,
  HighlightsFilter,
} from "./types";
import { getHighlightsLoadStatus } from "./selectors";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";

const getHighlights = createViewerAction(ViewerMethod.GET_HIGHLIGHTS);
export const highlightCurrentSelection = createViewerAction(
  ViewerMethod.HIGHLIGHT_CURRENT_SELECTION
);
export const goToHighlight = createViewerAction(ViewerMethod.GO_TO_HIGHLIGHT);
export const setHighlightsFilter = (
  filter: HighlightsFilter
): HighlightsAction => {
  return { type: HIGHLIGHTS_SET_FILTER, filter };
};
export const deleteHighlight = createViewerAction(
  ViewerMethod.DELETE_HIGHLIGHT
);

export const updateHighlight = createViewerAction(
  ViewerMethod.UPDATE_HIGHLIGHT
);

export const fetchHighlightsIfNeeded = () => (dispatch, getState) => {
  if (getHighlightsLoadStatus(getState()) === DetailedLoadStatus.WAITING) {
    return dispatch(getHighlights());
  }
};
